// import { useAuth } from "../../context/AuthContext";
// import { useNavigate } from "react-router-dom";
// import { useState, useEffect } from "react";
// import { toast } from "react-toastify";
// import "./Saved.css";
// const API_URL = process.env.REACT_APP_API_URL;

// export const fetchSavedQueries = async () => {
//   const res = await fetch(`${API_URL}/api/queries/saved`, {
//     method: "GET",
//     credentials: "include",
//   });

//   return res.json();
// };

// // export const deleteSavedQuery = async (id) => {
// //   const res = await fetch(`${API_URL}/api/queries/delete/${id}`, {
// //     method: "DELETE",
// //     credentials: "include",
// //   });

// //   return res.json();
// // };

// export const deleteSavedQuery = async (id) => {
//   try {
//     const res = await fetch(`${API_URL}/api/queries/delete/${id}`, {
//       method: "DELETE",
//       credentials: "include",
//     });

//     if (!res.ok) {
//       const errorData = await res.json(); // Try to get error details
//       throw new Error(errorData.message || `HTTP error! status: ${res.status}`);
//     }

//     const data = await res.json(); // This is the data you originally returned

//     toast.success("Query deleted successfully!", {
//       position: "top-center",
//       autoClose: 1500,
//       hideProgressBar: false,
//       closeOnClick: true,
//       pauseOnHover: true,
//       draggable: true,
//       progress: undefined,
//       theme: "dark",
//     });

//     return data; // Return the data from res.json()
//   } catch (error) {
//     console.error("Error deleting query:", error);

//     toast.error(error.message || "Failed to delete query. Please try again.", {
//       position: "top-center",
//       autoClose: 3000,
//       hideProgressBar: false,
//       closeOnClick: true,
//       pauseOnHover: true,
//       draggable: true,
//       progress: undefined,
//       theme: "dark",
//     });

//     throw error;
//   }
// };

// function Saved() {
//   const { user } = useAuth();
//   const navigate = useNavigate();
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [savedQueries, setSavedQueries] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");

//   useEffect(() => {
//     const loadSavedQueries = async () => {
//       const data = await fetchSavedQueries();
//       setSavedQueries(data);
//     };
//     loadSavedQueries();
//   }, []);

//   const filteredQueries = savedQueries.filter((query) =>
//     query.query.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   const handleDelete = async (id) => {
//     await deleteSavedQuery(id);
//     setSavedQueries(savedQueries.filter((q) => q._id !== id));
//   };

//   // Dashboard.js - Updated logout handler
//   const handleLogout = async () => {
//     try {
//       const response = await fetch(`${API_URL}/auth/logout`, {
//         method: "GET",
//         credentials: "include",
//         headers: {
//           "Content-Type": "application/json",
//         },
//       });

//       if (!response.ok) throw new Error("Logout failed");

//       window.location.href = "/";
//       toast.success("Logout successful!", {
//         position: "top-center",
//         autoClose: 1500,
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//         progress: undefined,
//         theme: "dark",
//       });
//     } catch (error) {
//       console.error("Logout error:", error);
//       toast.error("Logout failed!", {
//         position: "top-center",
//         autoClose: 1500,
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//         progress: undefined,
//         theme: "dark",
//       });
//     }
//   };

//   const handleSaved = () => {
//     navigate("/saved-chats");
//   };

//   const parseResponse = (data) => {
//     if (!data) return null;

//     let text = typeof data === "string" ? data : data.response || "";

//     // Convert Markdown-style links [text](URL) → Clickable <a>
//     text = text.replace(
//       /\[([^\]]+)\]\((https?:\/\/[^\s]+)\)/g,
//       '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>'
//     );

//     // Convert **bold** → <b>bold</b>
//     text = text.replace(/\*\*(.*?)\*\*/g, "<b>$1</b>");

//     // Convert *italic* → <i>italic</i>
//     text = text.replace(/\*(.*?)\*/g, "<i>$1</i>");

//     // Convert #-style headings properly (e.g., ### → <h3>)
//     text = text.replace(
//       /(^|\n)(#{1,6})\s+(.+)/g,
//       (_, prefix, hashes, content) =>
//         `${prefix}<h${hashes.length}>${content}</h${hashes.length}>`
//     );

//     // Convert newlines to <br> for better readability
//     text = text.replace(/\n/g, "<br/>");

//     return (
//       <div>
//         {/* Render parsed response safely */}
//         <div dangerouslySetInnerHTML={{ __html: text }} />

//         {/* Handle References */}
//         {data.references &&
//           Array.isArray(data.references) &&
//           data.references.length > 0 && (
//             <div className="references">
//               <h4>References:</h4>
//               {data.references.map((ref, i) => (
//                 <button
//                   key={`reference-${i}`}
//                   onClick={() => window.open(ref.link, "_blank")}
//                   className="reference-button"
//                 >
//                   {ref.title}
//                 </button>
//               ))}
//             </div>
//           )}
//       </div>
//     );
//   };

//   const QueryCard = ({ query, handleDelete }) => {
//     const [isExpanded, setIsExpanded] = useState(false);
//     const [showReferences, setShowReferences] = useState(false);

//     const toggleExpansion = () => setIsExpanded(!isExpanded);

//     return (
//       <div className="query-card">
//         <div className="card-header">
//           <h3 className="query-text">{query.query}</h3>
//           <button
//             onClick={() => handleDelete(query._id)}
//             className="delete-btn"
//             aria-label="Delete query"
//           >
//             &times;
//           </button>
//         </div>

//         <div className={`response-text ${isExpanded ? "expanded" : ""}`}>
//           {parseResponse(query)}
//           {!isExpanded && <div className="fade-overlay" />}
//         </div>

//         <div className="card-footer">
//           <div className="reference-toggle">
//             {query.references?.length > 0 && (
//               <button
//                 className="reference-btn"
//                 onClick={() => setShowReferences(!showReferences)}
//               >
//                 {showReferences ? "Hide References" : "Show References"}
//               </button>
//             )}
//           </div>
//           <button onClick={toggleExpansion} className="expand-btn">
//             {isExpanded ? "Show Less" : "Show More"}
//           </button>
//         </div>

//         {showReferences && (
//           <div className="references-container">
//             {query.references.map((ref, i) => (
//               <a
//                 key={i}
//                 href={ref.link}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="reference-link"
//               >
//                 {ref.title}
//               </a>
//             ))}
//           </div>
//         )}
//       </div>
//     );
//   };

//   const handleHome = () => {
//     navigate("/dashboard");
//   };

//   return (
//     <div className="dashboard">
//       <nav className="dashboard__navbar">
//         <div className="dashboard__brand" onClick={handleHome}>
//           CrowsNest
//         </div>
//         <div className="dashboard__nav-links">
//           <button className="nav-buttons" onClick={handleHome}>
//             Home
//           </button>
//           <button className="nav-buttons" onClick={handleSaved}>
//             Saved
//           </button>
//           {/* <button className="nav-buttons">Billings</button> */}
//           <div
//             className="dashboard__profile"
//             onClick={() => setShowDropdown(!showDropdown)}
//           >
//             <img
//               src={user?.profilePic}
//               alt="Profile"
//               className="dashboard__avatar"
//               referrerPolicy="no-referrer"
//             />
//             {showDropdown && (
//               <div className="dashboard__dropdown">
//                 <div className="dashboard__user-info">
//                   <p className="dashboard__user-name">{user?.name}</p>
//                   <p className="dashboard__user-email">{user?.email}</p>
//                 </div>
//                 <button
//                   className="dashboard__logout-btn"
//                   onClick={handleLogout}
//                 >
//                   Logout
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>
//       </nav>
//       <div className="dashboard__content__saved">
//         <div className="saved-queries-container">
//           <div className="info-search-bar">
//             <h2>Saved Queries</h2>
//             <input
//               type="text"
//               placeholder="Search saved queries..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               className="search-bar"
//             />
//           </div>
//           {/* <div className="saved-queries-list">
//             {filteredQueries.map((query) => (
//               <div key={query._id} className="saved-query-item">
//                 <div className="query-text">
//                   <strong>Query:</strong> {query.query}
//                 </div>
//                 <div className="response-text">
//                   <strong>Response:</strong>
//                   {parseResponse(query)}
//                 </div>
//                 <button
//                   onClick={() => handleDelete(query._id)}
//                   className="delete-btn"
//                 >
//                   Delete
//                 </button>
//               </div>
//             ))}
//           </div> */}
//           <div className="saved-queries-grid">
//             {filteredQueries.map((query) => (
//               <QueryCard
//                 key={query._id}
//                 query={query}
//                 handleDelete={handleDelete}
//               />
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Saved;

// New
import React, { useState, useEffect, useRef } from "react";
import { useAuth } from "../../context/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import "./Saved.css";
import logoImage from '../SearchEngine/image.png';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchSavedQueries = async () => {
  try {
    const res = await fetch(`${API_URL}/api/queries/saved`, {
      method: "GET",
      credentials: "include",
    });

    if (!res.ok) {
      throw new Error("Failed to fetch saved queries");
    }

    return res.json();
  } catch (error) {
    console.error("Error fetching saved queries:", error);
    toast.error("Failed to load saved queries", {
      position: "top-center",
      autoClose: 1500,
    });
    return [];
  }
};

export const deleteSavedQuery = async (id) => {
  try {
    const res = await fetch(`${API_URL}/api/queries/delete/${id}`, {
      method: "DELETE",
      credentials: "include",
    });

    if (!res.ok) {
      const errorData = await res.json();
      throw new Error(errorData.message || `HTTP error! status: ${res.status}`);
    }

    const data = await res.json();

    toast.success("Query deleted successfully!", {
      position: "top-center",
      autoClose: 1500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    });

    return data;
  } catch (error) {
    console.error("Error deleting query:", error);

    toast.error(error.message || "Failed to delete query. Please try again.", {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    });

    throw error;
  }
};

function Saved() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [savedQueries, setSavedQueries] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const profileDropdownRef = useRef(null);

  useEffect(() => {
    const loadSavedQueries = async () => {
      setIsLoading(true);
      try {
        const data = await fetchSavedQueries();
        setSavedQueries(data);
      } catch (error) {
        console.error("Failed to load saved queries:", error);
      } finally {
        setIsLoading(false);
      }
    };
    
    loadSavedQueries();
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (profileDropdownRef.current && !profileDropdownRef.current.contains(event.target)) {
        setShowProfileDropdown(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const filteredQueries = savedQueries.filter((query) =>
    query.query.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleDelete = async (id) => {
    try {
      await deleteSavedQuery(id);
      setSavedQueries(savedQueries.filter((q) => q._id !== id));
    } catch (error) {
      console.error("Error deleting query:", error);
    }
  };

  const handleLogout = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/auth/logout`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) throw new Error("Logout failed");

      window.location.href = "/";
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  // Navigate to pages
  const navigateToHome = () => {
    navigate("/dashboard");
  };

  const navigateToSaved = () => {
    navigate("/saved-chats");
  };

  const parseResponse = (data) => {
    if (!data) return null;

    let text = typeof data === "string" ? data : data.response || "";

    // Convert Markdown-style links [text](URL) → Clickable <a>
    text = text.replace(
      /\[([^\]]+)\]\((https?:\/\/[^\s]+)\)/g,
      '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>'
    );

    // Convert **bold** → <b>bold</b>
    text = text.replace(/\*\*(.*?)\*\*/g, "<b>$1</b>");

    // Convert *italic* → <i>italic</i>
    text = text.replace(/\*(.*?)\*/g, "<i>$1</i>");

    // Convert #-style headings properly (e.g., ### → <h3>)
    text = text.replace(
      /(^|\n)(#{1,6})\s+(.+)/g,
      (_, prefix, hashes, content) =>
        `${prefix}<h${hashes.length}>${content}</h${hashes.length}>`
    );

    // Convert newlines to <br> for better readability
    text = text.replace(/\n/g, "<br/>");

    return (
      <div>
        {/* Render parsed response safely */}
        <div dangerouslySetInnerHTML={{ __html: text }} />

        {/* Handle References */}
        {data.references &&
          Array.isArray(data.references) &&
          data.references.length > 0 && (
            <div className="references">
              <h4>References:</h4>
              {data.references.map((ref, i) => (
                <button
                  key={`reference-${i}`}
                  onClick={() => window.open(ref.link, "_blank")}
                  className="reference-button"
                >
                  {ref.title}
                </button>
              ))}
            </div>
          )}
      </div>
    );
  };

  const QueryCard = ({ query, handleDelete }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [showReferences, setShowReferences] = useState(false);

    const toggleExpansion = () => setIsExpanded(!isExpanded);

    return (
      <div className="query-card">
        <div className="card-header">
          <h3 className="query-text">{query.query}</h3>
          <button
            onClick={() => handleDelete(query._id)}
            className="delete-btn"
            aria-label="Delete query"
          >
            &times;
          </button>
        </div>

        <div className={`response-text ${isExpanded ? "expanded" : ""}`}>
          {parseResponse(query)}
          {!isExpanded && <div className="fade-overlay" />}
        </div>

        <div className="card-footer">
          <div className="reference-toggle">
            {query.references?.length > 0 && (
              <button
                className="reference-btn"
                onClick={() => setShowReferences(!showReferences)}
              >
                {showReferences ? "Hide References" : "Show References"}
              </button>
            )}
          </div>
          <button onClick={toggleExpansion} className="expand-btn">
            {isExpanded ? "Show Less" : "Show More"}
          </button>
        </div>

        {showReferences && (
          <div className="references-container">
            {query.references.map((ref, i) => (
              <a
                key={i}
                href={ref.link}
                target="_blank"
                rel="noopener noreferrer"
                className="reference-link"
              >
                {ref.title}
              </a>
            ))}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="dashboard">
      
      <div className="app-header">
        <div className="logo-container">
          <div className="logo">
            <img 
              src={logoImage}
              alt="CrowsNest Logo" 
              className="logo-image"
            />
          </div>
        </div>
        <div className="nav-container">
          <nav className="main-nav">
            <a 
              onClick={navigateToHome} 
              className={`nav-link ${location.pathname === "/dashboard" ? "active" : ""}`} 
              style={{ cursor: "pointer" }}
            >
              Home
            </a>
            <a 
              onClick={navigateToSaved} 
              className={`nav-link ${location.pathname === "/saved-chats" ? "active" : ""}`} 
              style={{ cursor: "pointer" }}
            >
              Saved
            </a>
            <div className="user-profile" ref={profileDropdownRef}>
              <div 
                className="profile-dropdown-trigger"
                onClick={() => setShowProfileDropdown(!showProfileDropdown)}
              >
                <div className="profile-image">
                {user && user?.profilePic ? (
                <img src={user?.profilePic} alt={user?.name || "User"} />
                ) : (
                 <div className="profile-placeholder">
                  {user && user?.name ? user?.name.charAt(0).toUpperCase() : "U"}
                  </div>
                  )}
                </div>
              </div>
              
              {showProfileDropdown && (
                <div className="profile-menu">
                  <div className="profile-info">
                    <div className="profile-name">{user ? user.name : "User"}</div>
                    <div className="profile-email">{user ? user.email : ""}</div>
                  </div>
                  <div className="profile-divider"></div>
                  <div className="profile-menu-items">
                    <button className="logout-button" onClick={handleLogout}>
                      Logout
                    </button>
                  </div>
                </div>
              )}
            </div>
          </nav>
        </div>
      </div>

      <div className="dashboard__content__saved">
        <div className="saved-queries-container">
          <div className="info-search-bar">
            <h2>Saved Queries</h2>
            <input
              type="text"
              placeholder="Search saved queries..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-bar"
            />
          </div>
          
          {isLoading ? (
            <div className="loading-container">
              <div className="loader"></div>
              <p>Loading saved queries...</p>
            </div>
          ) : filteredQueries.length > 0 ? (
            <div className="saved-queries-grid">
              {filteredQueries.map((query) => (
                <QueryCard
                  key={query._id}
                  query={query}
                  handleDelete={handleDelete}
                />
              ))}
            </div>
          ) : (
            <div className="no-queries-message">
              <p>No saved queries found. Save some responses to see them here!</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Saved;
